import { gql } from '@apollo/client';

const DASHBOARD_GET_LATEST_PRODUCT_APP = gql`
  query DashboardGetLatestProductApp(
    $personId: ID!
    $type: ApplicationTypeEnum
    $subType: ApplicationSubTypeEnum
  ) {
    getLatestProductApp(personId: $personId, type: $type, subType: $subType) {
      id
      type
      subType
      enrollmentGroups {
        product {
          id
          planId
          planExternalId
          fullPremium
          region
          planVersion
          subsidizedPremium
          effectiveDate
          planVariant
        }
        applicants {
          id
          externalId
          personId
          isFiler
          type
        }
        subsidy {
          id
          amountElected
          amountEligible
          productId
        }
      }
    }
  }
`;

export default DASHBOARD_GET_LATEST_PRODUCT_APP;
